import { get as getProjection, fromLonLat } from 'ol/proj';
import { Point} from 'ol/geom';
import Feature from 'ol/Feature';
import {Circle as CircleStyle, Fill, Stroke, Style, Text, Icon} from 'ol/style';
import { reverseGeocoding } from '../services';

const options = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0
}

export const locateMe = async (map,mapRef,sourceSelect,setLocation,setSurveyLoadingScreen) => {  
     navigator.geolocation.getCurrentPosition(async (position) =>		 {
        const coordinates = fromLonLat([position.coords.longitude, position.coords.latitude], map.getView().getProjection());
        const center = new Point(coordinates);
        mapRef.current.getView().fit(center, {maxZoom: 20});
        sourceSelect.clear();	
        const centerpoint = new Feature({'geometry':center});         
        sourceSelect.addFeature(centerpoint);
        centerpoint.setStyle (new Style({
             text: new Text({
                 text: '\uf140',
                 scale: 1,
                 font: 'normal 25px FontAwesome',
                 fill: new Fill({color: '#fff'}),
                 stroke: new Stroke({
                     color: 'rgba(0, 0, 0, 0.6)',
                     width: 2
                 }),
             })
         }));
        const addressInfo = await reverseGeocoding(position.coords.latitude, position.coords.longitude)
        if(addressInfo?.address) {
             setLocation({coords: position.coords, ...addressInfo?.address, display_name: addressInfo?.display_name})
        }
        setSurveyLoadingScreen(false)
    }, (error) => {
        console.error(error)
        alert("Morate nam dati pristup vašoj lokaciji")
      
    }, options);
    
}

export const reverseGeocode = async (coords, setLocation) => {  
   
        
        // const centerpoint = new Feature({'geometry':center});		
        // sourceSelect.addFeature(centerpoint);
        // centerpoint.setStyle (new Style({
        //     text: new Text({
        //         text: '\uf024',
        //         scale: 1,
        //         font: 'normal 25px FontAwesome',
        //         fill: new Fill({color: '#fff'}),
        //         stroke: new Stroke({
        //             color: 'rgba(0, 0, 0, 0.6)',
        //             width: 2
        //         }),
        //     })
        // }));

    const addressInfo = await reverseGeocoding(coords.latitude, coords.longitude)
    //console.log("Get address info", coords, addressInfo)
    if(addressInfo?.address) {
        setLocation({coords: coords, ...addressInfo?.address, display_name: addressInfo?.display_name})
    }

}